// Meta Pixel (Facebook/Instagram Ads) – lädt nur mit gesetzter Pixel-ID
// UND erteilter Cookie-Einwilligung (DSGVO). Playbook: Browser-Pixel ohne Secret.
// Robust: Akzeptiert die reine ID ODER das komplette von Meta kopierte Snippet
// (dann wird die häufigste lange Ziffernfolge = Pixel-ID extrahiert).
const rawPixelId = process.env.REACT_APP_META_PIXEL_ID || "";
const extractPixelId = (raw) => {
  const trimmed = raw.trim();
  if (/^\d+$/.test(trimmed)) return trimmed;
  const candidates = raw.match(/\d{10,}/g) || [];
  if (!candidates.length) return "";
  return candidates.reduce((best, c) =>
    candidates.filter((x) => x === c).length > candidates.filter((x) => x === best).length ? c : best
  );
};
const pixelId = extractPixelId(rawPixelId);
const CONSENT_KEY = "ue24_consent";
let initialized = false;

export function isMetaPixelEnabled() {
  return Boolean(pixelId && /^\d+$/.test(pixelId));
}

function hasConsent() {
  try { return localStorage.getItem(CONSENT_KEY) === "accepted"; } catch { return false; }
}

function ensureFbq() {
  if (window.fbq) return;
  const fbq = function (...args) {
    if (fbq.callMethod) fbq.callMethod(...args);
    else fbq.queue.push(args);
  };
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];
  window.fbq = fbq;
  window._fbq = fbq;
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
}

export function initMetaPixel() {
  if (!isMetaPixelEnabled() || !hasConsent() || initialized) return false;
  ensureFbq();
  window.fbq("init", pixelId);
  initialized = true;
  return true;
}

export function trackMeta(eventName, params) {
  if (!isMetaPixelEnabled() || !hasConsent()) return;
  initMetaPixel();
  if (initialized) window.fbq("track", eventName, params || {});
}

// Standard-Events: PageView (jede Route), Lead (Formular erfolgreich), Contact (tel:/WhatsApp-Klick)
export function trackMetaPageView(path) {
  trackMeta("PageView", { page_path: path });
}

export function trackMetaLead(contentName) {
  trackMeta("Lead", { content_name: contentName });
}

// Custom-Events für Kampagnen-Auswertung (z. B. click_call_unfallort)
export function trackMetaCustom(eventName, params) {
  if (!isMetaPixelEnabled() || !hasConsent()) return;
  initMetaPixel();
  if (initialized) window.fbq("trackCustom", eventName, params || {});
}
